module.exports = __webpack_public_path__ + "img/mb-visual-background.d4555c22.png";